import React, { useContext } from 'react';
import { AppContext } from '../../context/Context';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material/';

function ModalWrongKioskUser() {
  const { t } = useTranslation();

  const { updateShowModalWrongKioskUser } = useContext(AppContext);

  const handleConfirm = () => {
    updateShowModalWrongKioskUser(false);
  };

  return (
    <div id="react-confirm-alert">
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          background: 'rgba(3,6,18,0.88)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 16px',
        }}
      >
        <div
          style={{
            width: 'min(760px, 96vw)',
            borderRadius: '24px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
            background:
              'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
            padding: '40px 48px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <Typography
            sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}
          >
            {t('kiosk.wrongUserTitle')}
          </Typography>
          <Typography
            sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '25px' }}
          >
            {t('kiosk.wrongUserMessage1')}
          </Typography>
          <Typography
            sx={{ color: 'white', fontSize: '25px', fontWeight: 700 }}
          >
            {t('kiosk.wrongUserMessage2')}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              variant="contained"
              startIcon={<CheckCircleIcon />}
              onClick={handleConfirm}
              sx={{
                height: 88,
                borderRadius: '16px',
                bgcolor: '#FFC727',
                color: '#000',
                fontWeight: 800,
                fontSize: 22,
                textTransform: 'uppercase',
                boxShadow: `0 12px 32px #FFC72766`,
                '&:hover': {
                  bgcolor: '#FFD54F',
                  transform: 'translateY(-2px)',
                  boxShadow: `0 16px 40px #FFC72788`,
                },
                '&:active': { transform: 'translateY(0)' },
              }}
            >
              {t('sales.confirm')}
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ModalWrongKioskUser;
